module.exports = __webpack_public_path__ + "media/smiles/happy_2-7918d9db.svg";